const SELECTOR = '[data-bdl-copy-coupon]';

/**
 * Delegation no document: funciona com N botões do marquee (grupo duplicado)
 * e sobrevive a re-render parcial do Theme Editor.
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest(SELECTOR);
  if (!button) return;

  const code = button.getAttribute('data-coupon');
  const label = button.querySelector('[data-bdl-copy-label]');
  if (!code || !label) return;

  const original = label.textContent;

  try {
    await navigator.clipboard.writeText(code);
    label.textContent = 'Cupom copiado!';
  } catch {
    label.textContent = 'Não foi possível copiar';
  }

  window.setTimeout(() => {
    label.textContent = original;
  }, 2000);
});
